import React, { Component } from "react";
import CompanyPage from "./company_page";
import CompanyForm from "./company_form";

class MyCompanyPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false
    };
  }

  handleEditButtonClick = () => {
    this.setState(prevState => (
      { isEditing: !prevState.isEditing }
    ));
  };

  render () {
    const { isEditing } = this.state;

    return isEditing === true ? (
      <CompanyForm
        {...this.props}
        handleEditButtonClick={this.handleEditButtonClick}
      />
    ) : (
      <CompanyPage
        {...this.props}
        handleEditButtonClick={this.handleEditButtonClick}
      />
    );
  }
}

export default MyCompanyPage;
